export default __webpack_public_path__ + "static/media/pptv-36.998af3c4.jpg";